var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrestadores(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "8 8 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10h32v32H8z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#A5ADBD",
    strokeLinecap: "round",
    strokeWidth: 2,
    className: "custom-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.473 19.128a16.89 16.89 0 0 1 4.333-4.209c6.902-4.655 15.8-3.533 19.874 2.506a11.804 11.804 0 0 1 1.97 5.632m-1.466 8.805a16.972 16.972 0 0 1-3.906 3.633c-6.902 4.656-15.8 3.534-19.874-2.506a11.765 11.765 0 0 1-1.92-5.153M17.149 20.529l-6.886.382m-.506-8.39.481 8.089M29.173 30.973l7.814.427m-.96 8.35.935-8.086"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestadores);
export default __webpack_public_path__ + "static/media/prestadores.112cdf2c1815fc55097155117bce6290.svg";
export { ForwardRef as ReactComponent };